export const iconFontAwesomeMedicalHealthCircleH = (
	<i className="fa-solid fa-circle-h"></i>
);
